module.exports = __webpack_public_path__ + "static/media/LV5@2x.eaf6f9a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV5@2x.png
// module id = 687
// module chunks = 0